/* eslint-disable react/prop-types */

function Spinner(props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
      }}
    >
      <div className="spinner-border" role="status"></div>
      <div style={{ fontSize: `${props.size}px` }}>
        {props.msg || "Loading..."}
      </div>{" "}
    </div>
  );
}

export default Spinner;
